<template>
  <div>
    <section>
      <TippCard
        hintID="Admin_Benutzer_Tab_Labels_1_V1"
        text="Labels dienen der einfachen Bündelung von Benutzern innerhalb der Organisation und Zuweisung von Berechtigungen. Einem Benutzer können mehrere Labels zugewiesen sein. Informationen werden in der Anwendung auch nach diesen Kriterien gefiltert."
      >
      </TippCard>
    </section>
    <section>
      <template>
        <v-container fluid>
          <v-row justify="center" align="center">
            <v-col cols="12">
              <Subheader
                icon="mdi-label"
                title="Label"
                :actions="actions"
              ></Subheader>
              <div class="mt-7">
                <v-data-table
                  :headers="headers"
                  :items="labels"
                  sort-by="sortKey"
                  :sort-desc="false"
                  class="elevation-2"
                  no-data-text="Keine Labels vorhanden"
                  @click:row="openDetails"
                >
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </template>
    </section>
  </div>
</template>

<script>
import TippCard from "@/components/_systemwide/Tipp_Card.vue";
import Subheader from "@/components/_systemwide/Subheader.vue";
import { ADMIN } from "@/store/modules.js";
import { GET_USER_LABELS } from "@/store/action-types.js";
import { ADMINISTRATION_USERS_LABELS_create } from "@/data/permission-types.js";

export default {
  name: "admin-users-tab-labels",
  components: {
    TippCard,
    Subheader,
  },
  data() {
    return {
      sortDesc: false,
      sortBy: "sortKey",
      headers: [
        {
          text: "Sortierschlüssel",
          value: "sortKey",
          divider: true,
        },
        {
          text: "Name",
          value: "title",
        },
        {
          text: "Beschreibung",
          value: "description",
        },
      ],
      actions: [
        {
          title: "Erstellen",
          icon: "mdi-plus-circle",
          permission: `${ADMINISTRATION_USERS_LABELS_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "admin-users-tab-labels-label-create",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },
        {
          title: "Importieren",
          icon: "mdi-file-import",
          permission: `${ADMINISTRATION_USERS_LABELS_create}`,
          actionStyle: "textBtn",
          function: () => {
            this.$router.push({
              name: "admin-users-tab-labels-label-import",
              params: {
                organizationId: this.$route.params.organizationId,
              },
            });
          },
        },
      ],
    };
  },
  computed: {
    userGroups() {
      return this.$store.state.admin.userGroups;
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.$store.dispatch(`${ADMIN}${GET_USER_LABELS}`, {
        organizationId: this.$route.params.organizationId,
      });
    },

    openDetails(item) {
      this.$router.push({
        name: "admin-users-tab-labels-label-details",
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: item.meta.id,
        },
      });
    },
  },
};
</script>
